import {createAction} from 'Shared/utilities/actionCreator';
import {RecruiterCodeDto} from 'Users/api';

export enum RecruiterCodeActionType {
  SEARCH_RECRUITER_CODES = 'recruiterCode/SEARCH_RECRUITER_CODES',
  CHANGE_RECRUITER_CODES = 'recruiterCode/CHANGE_RECRUITER_CODES',
}

export const searchRecruiterCodes = (recruiterCode: string) =>
  createAction(RecruiterCodeActionType.SEARCH_RECRUITER_CODES, {recruiterCode});
export const changeRecruiterCodes = (recruiterCodes: RecruiterCodeDto[]) =>
  createAction(RecruiterCodeActionType.CHANGE_RECRUITER_CODES, recruiterCodes);

type RecruiterCodeState = {
  recruiterCodes: RecruiterCodeDto[];
  loading: boolean;
};

export const DEFAULT_STATE: RecruiterCodeState = {
  recruiterCodes: [],
  loading: false,
};

type RecruiterCodeAction = ReturnType<typeof changeRecruiterCodes> | ReturnType<typeof searchRecruiterCodes>;

export default (state: RecruiterCodeState = DEFAULT_STATE, action: RecruiterCodeAction): RecruiterCodeState => {
  switch (action.type) {
    case RecruiterCodeActionType.SEARCH_RECRUITER_CODES:
      return {
        ...state,
        loading: true,
      };
    case RecruiterCodeActionType.CHANGE_RECRUITER_CODES:
      return {
        ...state,
        recruiterCodes: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
